import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Screen1 from "./screen1";
import Question from "./Question";
import Sample from "./sample.json"
import Conversation from "./Conversation";
import Finish from "./Finish";
import Language from "./Language";
import QuestionInput from "./QuestionInput";
import ToneSelection from "./ToneSelection";

const Demo = () =>{
    const [screen, setScreen] = useState(1)
    const [response, setResponse] = useState({})
    const [language, setLanguage] = useState("EN")
    const [customQuestions, setCustomQuestions] = useState([])
    const [selectedTone, setSelectedTone] = useState("balanced")

    // Add a function to handle screen changes with scroll reset
    const handleScreenChange = (newScreen) => {
        // Reset scroll position when changing screens
        window.scrollTo(0, 0);
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        
        // Change the screen
        setScreen(newScreen);
    };

    const saveResponse = (resp) =>{
        let _response = {...response}

        _response[screen] = resp

        setResponse(_response)      
    }

    const saveCustomQuestions = (questions) => {
        setCustomQuestions(questions);
    }

    const saveTone = (tone) => {
        setSelectedTone(tone);
    }

    // Update the useEffect to ensure global scroll behavior is correct
    useEffect(() => {
        // Only modify these styles once on mount
        const originalBodyStyle = document.body.style.overflow;
        const originalHtmlStyle = document.documentElement.style.overflow;
        const originalBodyHeight = document.body.style.height;
        const originalHtmlHeight = document.documentElement.style.height;
        
        // Set overflow to auto on body and html to ensure proper scrolling
        document.body.style.overflow = 'auto';
        document.documentElement.style.overflow = 'auto';
        document.body.style.height = 'auto';
        document.documentElement.style.height = 'auto';
        
        return () => {
            // Restore original styles when component unmounts
            document.body.style.overflow = originalBodyStyle;
            document.documentElement.style.overflow = originalHtmlStyle;
            document.body.style.height = originalBodyHeight;
            document.documentElement.style.height = originalHtmlHeight;
        };
    }, []); // Empty dependency array ensures this only runs once

    const renderScreen = () =>{

        if(screen === 1){
            return <Screen1 setScreen={()=>handleScreenChange(2)} language={language}/>
        }

        if(screen === 2){
            return <QuestionInput 
                    saveQuestions={saveCustomQuestions} 
                    setScreen={()=>handleScreenChange(3)} 
                    language={language}/>
        }

        if(screen === 3){
            return <ToneSelection 
                    saveTone={saveTone} 
                    setScreen={()=>handleScreenChange(4)} 
                    language={language}/>
        }

        // Use customQuestions if provided, otherwise fall back to Sample
        const questions = customQuestions.length > 0 ? customQuestions : Sample;
        
        if(screen < questions.length + 4){ // +4 because we have 3 screens before questions start
            return <Question 
                question={questions[screen-4]} 
                response={response?.[screen]?.response}
                language={language}
                tone={selectedTone} // Pass the selected tone to Question component
                saveResponse={(resp)=>saveResponse(resp)} 
                setScreen={()=>handleScreenChange(screen+1)}/>
        }

        if(screen === questions.length + 6){ // +6 for intro, question input, tone selection, questions, and conversation screens
            return <Finish 
                language={language}
                tone={selectedTone}
                responses={response} // Pass all responses to Finish for analysis
            />
        }

        return <Conversation 
            id={screen}
            language={language}
            tone={selectedTone} // Pass the selected tone to Conversation component
            responses={response}
            response={response?.[screen]?.response}
            saveResponse={(resp)=>saveResponse(resp)} 
            setScreen={()=>handleScreenChange(screen+1)} />
    }

    return (
        <Container>
            {/* <Language language={language} setLanguage={setLanguage} languages={["EN","FR","ES"]}/> */}
           {renderScreen()}
        </Container>
    )
}

export default Demo

const Container = styled.div`
    display: flex;
    justify-content: center;
    font-family: 'Raleway';
    align-items: center;
    min-height: 100vh;
    width: 100%;
    padding: 20px;
    overflow-y: auto;
    overflow-x: hidden;
`